var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDescriptionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5833 2.16663H5.33333C4.5 2.16663 3.75 2.83329 3.75 3.74996V16.25C3.75 16.6666 3.91667 17.0833 4.16667 17.3333C4.41667 17.6666 4.83333 17.75 5.25 17.75H14.6667C15.0833 17.75 15.5 17.5833 15.75 17.3333C16 17 16.1667 16.6666 16.1667 16.25V6.83329L11.5833 2.16663ZM10.75 7.66663V3.33329L15.0833 7.66663H10.75Z",
    fill: "#99D5EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 10.1666V15.75L11.5 14.0833L9.25 16.25L7 14.0833L9.25 11.8333L7.58333 10.1666H13.1667Z",
    fill: "#0096D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionIcon);
export default __webpack_public_path__ + "static/media/description-icon.8c931893b7d678143396f2859c57b78c.svg";
export { ForwardRef as ReactComponent };